import { Box, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetModelStatusQuery } from 'api/ml-service/ml-service';
import RecommendationsSettingsStatusChip from './recommendations-settings-status-chip/recommendations-settings-status-chip.component';
import RecommendationsSettingsConfigurations from './recommendations-settings-configurations/recommendations-settings-configurations.component';
import SkeletonWrapper from 'components/skeleton-wrapper/skeleton-wrapper.component';

const RecommendationsSettings = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetModelStatusQuery(null);

  return (
    <Stack gap={2} mt={2}>
      <Typography variant="subtitle2">
        {t('page.menus.recommendations.settings.subtitle')}
      </Typography>
      <Paper sx={{ p: 2 }} elevation={3}>
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
          <Typography variant="subtitle2" fontWeight="bold">
            {t('page.menus.recommendations.settings.modelStatus.label')}
          </Typography>

          <Typography variant="subtitle2" fontWeight="bold">
            {t(
              'page.menus.recommendations.settings.transactionsAnalyzedCount.label',
            )}
          </Typography>
          <SkeletonWrapper isLoading={isLoading}>
            <Typography>
              {data?.modelReady >= 0 ? (
                <RecommendationsSettingsStatusChip status={data.modelReady} />
              ) : null}
            </Typography>
          </SkeletonWrapper>
          <SkeletonWrapper isLoading={isLoading}>
            <Typography>{data?.transactionCount}</Typography>
          </SkeletonWrapper>
        </Box>
      </Paper>

      <RecommendationsSettingsConfigurations />
    </Stack>
  );
};

export default RecommendationsSettings;
